import PropTypes from 'prop-types';
import content from './content';

export default PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  subType: PropTypes.string,
  zone: PropTypes.number,
  metadata: PropTypes.objectOf(PropTypes.any),
  autofill: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
  }),
  items: PropTypes.arrayOf(content),
});
